module.exports = __webpack_public_path__ + "static/media/12.ec5231fd.jpg";